<template>
    <modal
        v-if="isActive"
        :show="showModal"
        :showContent="showContent"
        :pageTitle="title"
        :acl="acl"
        :url="url"
        @close="closeModal"
        :closeBtn="closeBtn"
        position="left"
        class="school-distance"
    >
        <template v-slot:content>
            <div class="panel-control d-flex flex-column flex-fill">
                <div class="panel-control-content d-flex flex-column flex-fill">
                    <div class="row">
                        <div class="col">
                            <span class="title"> {{ panelTitle }}</span>
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <form
                                class="flex-column flex-fill"
                                :class="[!startedProcess ? 'd-flex' : 'd-none']"
                                autocomplete="off"
                                @submit.prevent="process"
                                method="post"
                            >
                                <div
                                    class="panel"
                                    v-show="activePanel == panels[0]"
                                    :ref="panels[0]"
                                    :key="panels[0]"
                                    role="tabpanel"
                                    :aria-labelledby="panels[0]"
                                >
                                    <div class="row">
                                        <div
                                            class="col-12"
                                            :class="orderHome"
                                        >
                                            <MaterialSelect
                                                class="city-form-group city-bg mb-2"
                                                size="small"
                                                name="address"
                                                v-model="form.address"
                                                :title="titleDirection0"
                                                :placeholder="placeholderDirection0"
                                                label="name"
                                                :ajaxOptions="{
                                                    url: url.address
                                                }"
                                                :reduce="item => (item ? item : null)"
                                                @selected="onSelectEndpointAddress"
                                                @item-unselected="onRemoveEndpointAddress"
                                                v-validate="'required|min:3'"
                                                :inputClasses="[
                                                    {
                                                        'is-invalid': fnHasError('address', panels[0])
                                                    }
                                                ]"
                                                :error="fnFirstError('address', panels[0])"
                                            >
                                                {{ $t(`${idPanel}.form.home`) }}
                                                <template v-slot:option="{ option }">
                                                    <strong>{{ option.name }}</strong>
                                                    <br /><small>{{ option.parish }}</small>
                                                </template>
                                            </MaterialSelect>
                                        </div>

                                        <div
                                            class="col-12"
                                            :class="orderSchool"
                                        >
                                            <MaterialSelect
                                                class="city-form-group city-bg mb-2"
                                                size="small"
                                                name="school"
                                                v-model="form.school"
                                                :title="titleDirection1"
                                                :placeholder="placeholderDirection1"
                                                label="name"
                                                :ajaxOptions="{
                                                    url: url.school
                                                }"
                                                :reduce="item => (item ? item : null)"
                                                @selected="onSelectEndpointSchool"
                                                @item-unselected="onRemoveEndpointSchool"
                                                v-validate="'required|min:3'"
                                                :inputClasses="[
                                                    {
                                                        'is-invalid': fnHasError('school', panels[0])
                                                    }
                                                ]"
                                                :error="fnFirstError('school', panels[0])"
                                            >
                                                {{ $t(`${idPanel}.form.school`) }}
                                                <template v-slot:option="{ option }">
                                                    <strong>{{ option.name }}</strong
                                                    ><br /><small>{{ option.place }}</small>
                                                </template>
                                            </MaterialSelect>
                                        </div>
                                    </div>
                                    <div class="row no-gutters form-group btn-group-toggle-city main mb-sm-4">
                                        <div
                                            :class="'col-' + 12 / directions.length"
                                            :for="`direction-${item.id}`"
                                            v-for="(item, index) in directions"
                                            :key="index"
                                        >
                                            <label
                                                class="btn btn-sm btn-block z-depth-0"
                                                :class="{ active: item.id == form.direction }"
                                            >
                                                <input
                                                    type="radio"
                                                    name="toogle-direction"
                                                    :id="`direction-${item.id}`"
                                                    :value="item.id"
                                                    v-model="form.direction"
                                                    autocomplete="off"
                                                />
                                                <span class="">{{ item.name }}</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <div
                                                class="text-justify text-muted mb-3"
                                                v-html="$t(`${idPanel}.form.description`)"
                                            ></div>
                                        </div>
                                    </div>

                                    <div class="row form-btns">
                                        <div class="text-center col-sm-12">
                                            <button
                                                :disabled="loading || !isValidToProcess"
                                                class="btn btn-main btn-rounded btn-sm btn-block min-w-auto"
                                                type="submit"
                                            >
                                                {{ buttons['finish'] }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <!-- PROCESS WORKFLOW -->
                            <process-workflow
                                v-if="startedProcess"
                                :url="url.status"
                                :id="idProcess"
                                :titleList="processTitleList"
                                :description="processDescription"
                                :emptyResult="processEmpty"
                                :errorResult="processError"
                                :canceled="canceledProcess"
                                :showBtnClose="closeBtn"
                                titleBtnClose="Voltar"
                                @completed="onCompletedProcess"
                                @close="onBack"
                            >
                                <template v-slot:completedJob="{ dataJob, isFailedJob, titleList, description, errorResult, emptyResult }">
                                    <div
                                        class="innerDetails"
                                        v-if="dataJob"
                                    >
                                        <div v-if="dataJob.distance">
                                            <p>
                                                <strong>Distância Total:</strong>&nbsp;<span class="distance font-family-meddium text-btn-link">{{ dataJob.distance }}</span>
                                            </p>
                                            <p class="small">{{ processDistanceDescripton }}</p>
                                        </div>
                                        <ul
                                            class="group-list-route list-unstyled"
                                            v-if="dataJob.route.length"
                                        >
                                            <li>
                                                <div>
                                                    <span
                                                        ><strong>{{ titleList }}</strong></span
                                                    >
                                                    <ul class="list-route mb-3">
                                                        <li
                                                            class="item-route"
                                                            v-for="(item, idx) in dataJob.route"
                                                            :key="idx"
                                                        >
                                                            {{ item.name }}<span v-if="item.distance">,&nbsp;{{ item.distance }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                        <hr class="my-3" />
                                        <p class="small">{{ description }}</p>
                                    </div>
                                    <div
                                        id="noOutput"
                                        v-else
                                    >
                                        <span
                                            class="txt-error"
                                            v-if="isFailedJob"
                                            >{{ errorResult }}</span
                                        >
                                        <span
                                            v-else
                                            v-html="emptyResult"
                                        ></span>
                                    </div>
                                </template>
                                <template v-slot:footer-prepend>
                                    <button
                                        v-if="enableExport"
                                        class="btn btn-main btn-rounded btn-sm btn-block min-w-auto"
                                        type="button"
                                        @click.prevent="onExportToKml"
                                    >
                                        {{ buttons['export'] }}
                                    </button>
                                </template>
                            </process-workflow>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import ButtonControlMixin from '../mixins/ButtonControlMixin';
import ProcessJobMixin from '@/app/shared/components/workflow/mixins/ProcessJobMixin';
import { default as IdentifyInteraction, IdentifyEventType } from '@/components/maps/ol/interaction/Identify';
import { formatString } from '@config/utils';
import { MAP_ACTIONS } from '@config/constants';
import VectorLayer from 'ol/layer/Vector';
import { Vector as VectorSource } from 'ol/source';
import { fromExtent } from 'ol/geom/Polygon';
import KML from 'ol/format/KML';
import { getCenter } from 'ol/extent';
import Collection from 'ol/Collection';

let varsOriginal = {
    interaction: null,
    directionLayer: null,
    keyHome: 'address',
    keySchool: 'school'
};

let vars = Object.assign({}, varsOriginal);

export default {
    mixins: [ButtonControlMixin, ProcessJobMixin],
    components: {
        Modal: () => import(/* webpackChunkName: "modal-data" */ '@/app/shared/components/modals/ModalData'),
        ProcessWorkflow: () => import(/* webpackChunkName: "common-process-workflow" */ '@/app/shared/components/workflow/CommonProcessWorkflow')
    },
    props: {
        closeBtn: {
            type: Boolean,
            default: true
        },
        sideBarWidth: {
            type: Number,
            default: 378
        },
        processDescription: {
            type: String,
            default: ''
        },
        processDistanceDescripton: {
            type: String,
            default: ''
        },
        processError: {
            type: String,
            default: ''
        },
        processTitleList: {
            type: String,
            default: ''
        },
        processEmpty: {
            type: String,
            default: ''
        }
    },
    data() {
        const idPanel = 'schooldistance';
        return {
            idPanel: idPanel,
            className: `ol-${idPanel}`,
            showContent: true,
            loading: false,
            buttons: {
                finish: 'Processar',
                export: 'Exportar',
                close: 'Fechar'
            },
            panels: ['panel-form'],
            panelSelected: null,
            form: {
                direction: null,
                address: null,
                school: null
            },
            directionFeatures: new Collection(),
            endpointFeatures: new Collection(),
            baseFilenameKml: ':name.kml'
        };
    },
    computed: {
        config() {
            return {
                placeholderSelectOrigin: this.$t(`${this.idPanel}.form.placeholderSelectOrigin`),
                placeholderSelectDestination: this.$t(`${this.idPanel}.form.placeholderSelectDestination`),
                placeholderDestination: this.$t(`${this.idPanel}.form.placeholderDestination`),
                icons: {}
            };
        },
        directions() {
            return [
                { id: `${vars.keyHome}-${vars.keySchool}`, name: this.$t(`${this.idPanel}.form.directions.homeSchool`) },
                { id: `${vars.keySchool}-${vars.keyHome}`, name: this.$t(`${this.idPanel}.form.directions.schoolHome`) }
            ];
        },
        enableExport() {
            return this.checkPermission(this.acl, 'export');
        },
        showModal() {
            return this.isActive && this.isPanelVisible;
        },
        activePanel() {
            return this.panelSelected ? this.panelSelected : this.panels[0];
        },
        configMap() {
            return this.$store.getters[`${this.moduleCode}/getConfigMap`];
        },
        panelTitle() {
            return 'Distância ' + this.directionTitle;
        },
        directionTitle() {
            let parts = this.form.direction ? this.form.direction.split('-') : [];
            return parts.findIndex(p => p == vars.keyHome) == 0 ? 'Casa / Escola' : 'Escola / Casa';
        },
        configLayers() {
            return this.configMap.layers.draw;
        },
        filenameKml() {
            return this.baseFilenameKml.replace(':name', `${this.sourceData.name}-${this.targetData.name}`);
        },
        endpointFeaturesCount() {
            return this.endpointFeatures.getLength();
        },
        orderHome() {
            let parts = this.form.direction ? this.form.direction.split('-') : [];
            let index = parts.findIndex(p => p == vars.keyHome) + 1;
            return `order-${index < 1 ? 1 : index}`;
        },
        orderSchool() {
            let parts = this.form.direction ? this.form.direction.split('-') : [];
            let index = parts.findIndex(p => p == vars.keySchool) + 1;
            return `order-${index < 1 ? 1 : index}`;
        },
        isValidToProcess() {
            return !!(this.form.address && this.form.school);
        },
        titleDirection0() {
            return this.form.address ? null : this.placeholderDirection0;
        },
        titleDirection1() {
            return this.form.school ? null : this.placeholderDirection1;
        },
        placeholderDirection0() {
            return this.config.placeholderSelectOrigin;
        },
        placeholderDirection1() {
            return this.form.address ? this.config.placeholderSelectDestination : this.config.placeholderDestination;
        },
        sourceData() {
            return this.endpointOrder(vars.keyHome) == 0 ? this.form.address : this.form.school;
        },
        targetData() {
            return this.endpointOrder(vars.keyHome) == 0 ? this.form.school : this.form.address;
        },
        dataForm() {
            return {
                name: this.directionTitle,
                source_id: this.sourceData.street_id,
                source_pos: this.sourceData.position,
                target_id: this.targetData.street_id,
                target_pos: this.targetData.position
            };
        }
    },
    mounted() {
        // Must be an absolute URL because of export to KML
        let baseUrl = window.location.href.replace(window.location.hash, '').replace(/\/$/, '');
        this.config.icons[vars.keyHome] = `${baseUrl}${this.assetsPathTheme(`/icons/pin-${vars.keyHome}.svg`)}`;
        this.config.icons[vars.keySchool] = `${baseUrl}${this.assetsPathTheme(`/icons/pin-${vars.keySchool}.svg`)}`;
    },
    methods: {
        addButtonMap: function (_map) {
            if (!_map) return false;

            let btn = _map.createBtnImg(
                this.assetsPathTheme('/map/print-visible.svg'),
                _map.getControlClassName(this.orderClassName),
                this.title,
                [
                    {
                        type: 'click',
                        event: evt => {
                            this.openPanel(this.idPanel);
                            evt.stopPropagation();
                        }
                    }
                ],
                this.lblBtn
            );
            _map.addControl(this.posBtnMap, btn);
            this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', evt => {
                let el = $(btn.element);
                if (el) el.hide();
            });
            this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', evt => {
                let el = $(btn.element);
                if (el) el.show();
            });
            return btn;
        },
        initialize: function () {
            this.form.direction = this.directions[0].id;
            if (this.createLayers()) {
                this.createInteraction();
                this.$store.dispatch(`setActionMap`, { module: this.moduleCode, action: MAP_ACTIONS.SCHOOL_DISTANCE });
            }
        },
        closeModal: function () {
            this.closePanel();
        },
        onBack: function () {
            this.resetJob();
            this.clearDirectionLayer();
        },
        createInteraction() {
            let interaction = vars.interaction;
            if (!interaction) {
                let _map = this.getMap();
                let interaction = new IdentifyInteraction({});
                interaction.on(IdentifyEventType.IDENTIFYCOORD, evt => {
                    let endpoint = this.form[vars.keyHome] != null ? vars.keySchool : vars.keyHome;
                    this.createEndpointFeature(evt.coordinate, endpoint).then(feature => {
                        this.setEndpointSearchBox(feature);
                    });
                });
                interaction.setActive(false);
                vars.interaction = interaction;
                _map.addInteraction(interaction);
                this.setMapInteraction(true);
            }
        },
        setMapInteraction(flag) {
            let interaction = vars.interaction;
            if (interaction) {
                interaction.setActive(flag);
            }
        },
        removeInteraction: function () {
            let interaction = vars.interaction;
            if (interaction) {
                let _map = interaction.getMap();
                if (_map) {
                    _map.removeInteraction(interaction);
                }
                vars.interaction = null;
            }
        },
        createLayers: function () {
            const _map = this.getMap();
            const config = this.configLayers;
            const zIndex = config.zindex;
            let _source = _map.getSource(config.source);
            let _layer = _map.getLayer(config.layer);
            if (!_layer) {
                if (!_source) {
                    _source = _map.createVectorSource({
                        features: []
                    });
                    _map.setSource(config.source, _source);
                }
                _layer = _map.createVectorLayer({
                    source: _source,
                    zIndex: zIndex
                });
                _map.setLayer(config.layer, _layer);
                _map.addlayerToMap({ layer: _layer });
            }
            _source.clear();

            let layer = vars.directionLayer;
            if (!layer) {
                let source = new VectorSource({
                    useSpatialIndex: true,
                    wrapX: config.wrapX !== undefined ? config.wrapX : false, //Wrap the world horizontally on the sketch overlay.
                    features: this.directionFeatures
                });

                layer = new VectorLayer({
                    source: source,
                    visible: true,
                    zIndex: zIndex - 1
                });
                _map.addLayer(layer);
                vars.directionLayer = layer;
            }
            return layer;
        },
        addFeaturesDirectionLayer: function (features) {
            let layer = vars.directionLayer;
            if (layer && features) {
                let source = layer.getSource();
                source.addFeatures(features);
                source.changed();
                this.zoomToExtent(source);
            }
        },
        clearDirectionLayer: function () {
            let layer = vars.directionLayer;
            if (layer) {
                let source = layer.getSource();
                source.clear();
                source.changed();
            }
        },
        async createEndpointFeature(coordinates, endpoint, index = undefined) {
            const _map = this.getMap();
            this.removeEndpointFeature(endpoint, false);
            let feature = _map.createFeature({
                id: `${endpoint}_endpoint`,
                longitude: coordinates[0],
                latitude: coordinates[1],
                style: this.getStyle(endpoint),
                properties: {
                    endpoint
                }
            });
            this.endpointFeatures.push(feature);
            this.updateEndpointFeaturesOnMap();
            return feature;
        },
        removeEndpointFeature: function (endpoint, updateMap = true) {
            this.endpointFeatures.forEach((item, index) => {
                if (item && item.get('endpoint') == endpoint) {
                    this.endpointFeatures.remove(item);
                    return;
                }
            });
            if (updateMap) {
                this.updateEndpointFeaturesOnMap();
            }
        },
        updateEndpointFeaturesOnMap: function () {
            let _source = this.getEndpointsSource();
            if (_source) {
                _source.clear();
                this.endpointFeatures.forEach(item => {
                    if (item) {
                        _source.addFeature(item);
                    }
                });
                _source.changed();
            }
            // this.setMapInteraction(this.endpointFeatures.getArray().filter(f => !!f).length < 2);
        },

        clearSourceTerminals: function () {
            this.endpointFeatures.clear();
            this.updateEndpointFeaturesOnMap();
        },
        zoomToExtent: function (source = undefined) {
            let _source = source ? source : this.getEndpointsSource();
            if (_source) {
                let extent = _source.getExtent();
                if (extent) {
                    const _map = this.getMap();
                    let num = _source.getFeatures().length;
                    const options = _map.getLayersProperties();
                    let size = _map.getOLMap().getSize();
                    let view = _map.getOLMapView();
                    if (num == 1) {
                        view.animate({
                            center: getCenter(extent),
                            zoom: view.getMaxZoom() - 2,
                            duration: options.duration
                        });
                    } else {
                        let geom = fromExtent(extent);
                        geom.scale(1.25);
                        extent = geom.getExtent();
                        let resolution = view.getResolutionForExtent(extent);
                        view.fit(geom.getExtent(), {
                            size: [size[0] - this.sideBarWidth, size[1]],
                            padding: [0, 0, 0, this.sideBarWidth],
                            duration: options.duration
                        });
                    }
                }
            }
        },
        getStyle: function (endpoint) {
            const _map = this.getMap();
            if (!_map) {
                return null;
            }
            return _map.createStyle({
                cursor: 'pointer',
                image: _map.createIcon({
                    src: this.config.icons[endpoint],
                    anchor: [0.5, 1],
                    scale: 1
                })
            });
        },
        getSegmentStyle: function () {
            const _map = this.getMap();
            if (!_map) {
                return null;
            }
            return _map.createStyle({
                stroke: {
                    color: '#ff7814cc', //'rgba(255, 120, 20, 0.8)', //'#FF7814',
                    width: 7
                }
                // zIndex: config.zIndex || 9
            });
        },
        getEndpointsSource: function () {
            const _map = this.getMap();
            if (_map) {
                const config = this.configLayers;
                return _map.getSource(config.source);
            }
        },
        reset: function () {
            Object.assign(this.$data.form, this.$options.data().form);
            this.resetJob();
            if (this.getMap()) {
                this.clearSourceTerminals();
                let layer = vars.directionLayer;
                if (layer) {
                    this.removeInteraction();
                    layer.getSource().clear();
                    this.getMap().removeLayer(layer);
                    vars.directionLayer = null;
                }
            }
            this.panelSelected = null;
            vars = Object.assign({}, varsOriginal);
            this.directionFeatures = new Collection();
            this.endpointFeatures = new Collection();
            this.resetValidator();
            this.$store.dispatch(`setActionMap`, { module: this.moduleCode, action: null });
        },
        onSelectEndpointAddress: function (item) {
            this.createEndpointFeature([item.lng, item.lat], vars.keyHome, 0).then(res => {
                this.zoomToExtent();
            });
        },
        onRemoveEndpointAddress: function (item) {
            this.removeEndpointFeature(vars.keyHome);
        },
        onSelectEndpointSchool: function (item) {
            this.createEndpointFeature([item.lng, item.lat], vars.keySchool, 1).then(res => {
                this.zoomToExtent();
            });
        },
        onRemoveEndpointSchool: function (item) {
            this.removeEndpointFeature(vars.keySchool);
        },
        setEndpointSearchBox: function (feature) {
            this.setLoading(true);
            let endpoint = this.form[vars.keyHome] != null ? vars.keySchool : vars.keyHome;
            this.getAddressFromPosition(endpoint, feature.getGeometry().getCoordinates())
                .then(data => {
                    let obj = {};
                    obj[endpoint] = data;
                    Object.assign(this.form, obj);
                })
                .catch(error => {
                    this.showHttpError(error);
                })
                .finally(() => {
                    this.setLoading(false);
                });
        },
        async getAddressFromPosition(endpoint, coordinates) {
            let url = formatString(this.url[`${endpoint}FromPosition`], { lng: coordinates[0], lat: coordinates[1] });
            return await this.$http
                .get(url)
                .then(res => {
                    let data = res.data.data ? res.data.data : res.data;
                    return data;
                })
                .catch(error => {
                    this.showHttpError(error);
                    return null;
                });
        },
        endpointOrder(key) {
            let parts = this.form.direction ? this.form.direction.split('-') : [];
            return parts.findIndex(p => p == key);
        },
        setLoading: function (flag) {
            this.loading = flag;
        },
        process: function () {
            try {
                this.loading = true;
                this.clearMessages();
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.showError('Por favor corrija os erros no formulário');
                        return;
                    }

                    this.$http
                        .post(this.url.route, this.dataForm)
                        .then(res => {
                            let data = res.data.data;
                            if (data && data.jobId) {
                                this.job.id = data.jobId;
                            } else {
                                this.showError(data);
                            }
                        })
                        .catch(error => {
                            this.showHttpError(error);
                        })
                        .finally(() => (this.loading = false));
                });
            } catch (err) {
                this.showError(err);
            } finally {
                this.loading = false;
            }
        },
        onCompletedProcess: function (params = {}) {
            this.clearDirectionLayer();
            let data = params?.data;
            if (data && data.route) {
                let route = data.route;
                let _map = this.getMap();
                let features = [];
                data.route.forEach(segment => {
                    let feature = _map.createFeatureFromGeojson({
                        id: `segment-${segment.seq}`,
                        properties: {},
                        geom: segment.geojson,
                        style: this.getSegmentStyle()
                    });
                    features.push(feature);
                });
                this.addFeaturesDirectionLayer(features);
            }
        },
        onExportToKml: function () {
            if (!this.enableExport) {
                return;
            }

            let _view = this.getMap().getOLMapView();
            let features = [...vars.directionLayer.getSource().getFeatures()];
            let _source = this.getEndpointsSource();
            if (_source) {
                let endpoints = _source.getFeatures();
                if (endpoints.length > 1) {
                    features.unshift(endpoints[0].clone());
                    features.push(endpoints[1].clone());
                }
            }

            let format = new KML({
                extractStyles: true,
                writeStyles: true,
                showPointNames: true
            });
            let contentKml = format.writeFeatures(features, {
                featureProjection: _view.getProjection()
            });

            if (contentKml) {
                let contentType = 'application/vnd.google-earth.kml+xml';
                if (contentKml != null && navigator.msSaveBlob) return navigator.msSaveBlob(new Blob([contentKml], { type: contentType }), this.filenameKml);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(new Blob([contentKml], { type: contentType }));
                a.setAttribute('href', url);
                a.setAttribute('download', this.filenameKml);
                document.body.append(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            }
        }
    },
    watch: {
        showModal: {
            immediate: false,
            handler(newValue, oldValue) {
                if (newValue) {
                    this.initialize();
                } else {
                    this.reset();
                }
            }
        },
        endpointFeaturesCount: {
            immediate: false,
            handler(newValue, oldValue) {
                this.setMapInteraction(newValue < 2);
            }
        }
    }
};
</script>

<style lang="scss">
.school-distance {
    .city-form-group {
        input[type='search'] {
            &::placeholder {
                font-size: 80% !important;
                font-weight: 400 !important;
            }
            &::-webkit-input-placeholder {
                font-size: 80% !important;
                font-weight: 400 !important;
            }
            &::-moz-placeholder {
                font-size: 80% !important;
                font-weight: 400 !important;
            }
            &:-ms-input-placeholder {
                font-size: 80% !important;
                font-weight: 400 !important;
            }
            &:-moz-placeholder {
                font-size: 80% !important;
                font-weight: 400 !important;
            }
        }
    }

    .distance {
        letter-spacing: 1px;
    }

    ul {
        ul {
            list-style-position: inside;
            padding-left: 0;
            margin-left: 0;
        }
    }
}
</style>
